let socket = null;
let pingInterval = null;
let reconnectTimeout = null;

export const connectToTradeSocket = (loginId, onMessage) => {
  const url = `wss://api.brokercheap.com:8013/ws/trade?login=${loginId}`;
  socket = new WebSocket(url);

  socket.onopen = () => {
    console.log('Trade WebSocket connected');
    pingInterval = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 30000); // every 30 seconds
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'deal' && onMessage) {
        onMessage(data.deal);
      }
    } catch (err) {
      console.error('WebSocket parse error:', err, 'Data:', event.data);
    }
  };

  socket.onerror = (err) => {
    console.error('WebSocket error:', err);
  };

  socket.onclose = () => {
    console.log('Trade WebSocket disconnected');
    clearInterval(pingInterval);
    reconnectTimeout = setTimeout(() => {
      console.log('Reconnecting to Trade WebSocket...');
      connectToTradeSocket(loginId, onMessage);
    }, 1000); // Retry after 5 seconds
  };
};

export const disconnectFromTradeSocket = () => {
  if (socket) {
    clearInterval(pingInterval);
    clearTimeout(reconnectTimeout);
    socket.close();
    socket = null;
  }
};
